// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"8d07ed6d","453":"3ea42793","472":"b3559bc2","497":"0a2543d4","966":"f255e563"}[chunkId] + ".chunk.js";
};